var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicrophoneOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6666 7.33334C12.6666 8.57101 12.1749 9.758 11.2997 10.6332C10.4246 11.5083 9.2376 12 7.99992 12M7.99992 12C6.76224 12 5.57526 11.5083 4.70009 10.6332C3.82492 9.758 3.33325 8.57101 3.33325 7.33334M7.99992 12V14.6667M7.99992 14.6667H5.33325M7.99992 14.6667H10.6666M7.99992 9.33334C7.46949 9.33334 6.96078 9.12262 6.5857 8.74755C6.21063 8.37248 5.99992 7.86377 5.99992 7.33334V3.33334C5.99992 2.8029 6.21063 2.2942 6.5857 1.91912C6.96078 1.54405 7.46949 1.33334 7.99992 1.33334C8.53035 1.33334 9.03906 1.54405 9.41413 1.91912C9.7892 2.2942 9.99992 2.8029 9.99992 3.33334V7.33334C9.99992 7.86377 9.7892 8.37248 9.41413 8.74755C9.03906 9.12262 8.53035 9.33334 7.99992 9.33334Z",
    stroke: "#09090B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrophoneOutline);
export default __webpack_public_path__ + "static/media/MicrophoneOutline.fdaf01c8c27eab9ddeffdd7aadc2d8ef.svg";
export { ForwardRef as ReactComponent };